import { REMOVE_INVALID_CUSTOM_FIELD, SET_REG_CART_FIELD_VALUE, SET_TEMPORARY_GUEST_FIELD_VALUE } from './actionTypes';

function setRegCartFieldValue(path, value) {
  return {
    type: SET_REG_CART_FIELD_VALUE,
    payload: { path, value }
  };
}

function eventRegistrationPrefix(eventRegistrationId) {
  return ['eventRegistrations', eventRegistrationId];
}

export function setEventRegistrationFieldValue(eventRegistrationId, path, value) {
  return setRegCartFieldValue([...eventRegistrationPrefix(eventRegistrationId), ...path], value);
}

export function setTemporaryGuestFieldValue(path, value) {
  return {
    type: SET_TEMPORARY_GUEST_FIELD_VALUE,
    payload: { path, value }
  };
}

export function removeInvalidCustomField(eventRegistrationId,
  fieldId) {
  return {
    type: REMOVE_INVALID_CUSTOM_FIELD,
    payload: {
      fieldId,
      path: [...eventRegistrationPrefix(eventRegistrationId), 'attendee', 'personalInformation', 'customFields']
    }
  };
}

export function updateAdmin(admin) {
  return async (dispatch) => {
    dispatch(setRegCartFieldValue(['admin'], admin));
  };
}

export function updateEventRegistrations(eventRegistrations) {
  return async (dispatch) => {
    dispatch(setRegCartFieldValue(['eventRegistrations'], eventRegistrations));
  };
}

export function updateEventVoucher(eventRegistrationId, voucherCode) {
  return async (dispatch) => {
    dispatch(setRegCartFieldValue([...eventRegistrationPrefix(eventRegistrationId),
      'appliedVoucher', 'voucherCode'], voucherCode));
  };
}

export function setAppointmentsAvailability(eventRegistrationId, availability) {
  return setRegCartFieldValue([...eventRegistrationPrefix(eventRegistrationId), 'appointmentsAvailability'],
    availability);
}

export function setAppointmentsMeetingInterest(eventRegistrationId, meetingInterest) {
  return setRegCartFieldValue([...eventRegistrationPrefix(eventRegistrationId), 'appointmentsMeetingInterest'],
    meetingInterest);
}

export function setSendEmailFlag(sendEmail) {
  return setRegCartFieldValue(['sendEmail'], sendEmail);
}

export function saveLocaleId(localeId) {
  return setRegCartFieldValue(['localeId'], localeId);
}
